<template>
  <div class="modal " id="addAsgModal" tabindex="-1" aria-labelledby="addAsgModallabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="addAsgMod">ADD ASSESSMENT</h5>
          <div class="close-container myfaBtn" data-bs-dismiss="modal" aria-label="Close">
            <div class="leftright"></div>
            <div class="rightleft"></div>
          </div>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group padRt10 mb-2">
                <label style="padding-left:0px;" class="">Enter Assessment Name<span class="text-danger ">*</span>
                  <span class="myInfoI cursor-pointer float-right ms-2">
                    <font-awesome-icon icon="fa-solid fa-circle-info" />
                  </span>
                  <span class="myInfoS">
                    Please enter Assessment Name.
                  </span>
                </label>
                <input class="form-control col-sm-12" type="text" placeholder="eg. Ticket data, Account Incidents, etc." v-model="AssessName" maxlength="50" autofocus>
              </div>
              <div class="form-group padRt10 mb-2 d-flex align-items-center justify-content-between position-relative">
                <label style="padding-left:0px;" class="">Test Assessment
                  <span class="myInfoI cursor-pointer float-right  ms-2">
                    <font-awesome-icon icon="fa-solid fa-circle-info" />
                  </span>
                  <span class="myInfoS">
                    Please select if this assessment is used for testing/learning. This is important so that these test
                    assesments won't impact benchmarking and be used to retrain the AI models.
                  </span></label>
                <div class="col-4 pt-2 text-end">
                  <input type="checkbox" class="switch_1 ms-1 " step="margin-top:5px;" v-model='isTestAssessment'>
                </div>
              </div>
              <div class="form-group padRt10 mb-2" v-show="!isTestAssessment">
                <div class="d-flex align-items-center justify-content-between position-relative">
                  <label style="padding-left:0px"><span>Assessment is for RFP/RFI <span class="text-danger">*</span>
                    </span>
                    <span class="myInfoI cursor-pointer float-right  ms-2">
                      <font-awesome-icon icon="fa-solid fa-circle-info" />
                    </span>
                    <span class="myInfoS">
                      Mention whether this analysis is used for RFP/RFI.
                    </span>
                  </label>
                  <div class="col-4 ps-1">
                    <div class="groupRadio">
                      <input type="radio" name="rb" id="rb1" v-model="isRfp" value="Yes" class="radBtn"/>
                      <label for="rb1" class="radBtnLbl">Yes</label>
                      <input type="radio" name="rb" id="rb2" v-model="isRfp" value="No"  class="radBtn radBtnNo"/>
                      <label for="rb2" class="radBtnLbl">No</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group padRt10 mb-2" v-show="!isTestAssessment">
                <div class="d-flex align-items-center justify-content-between position-relative">
                  <label style="padding-left:0px"><span>Avail APPM feature<span class="text-danger">*</span>
                    </span>
                    <span class="myInfoI cursor-pointer float-right  ms-2">
                      <font-awesome-icon icon="fa-solid fa-circle-info" />
                    </span>
                    <span class="myInfoS">
                      Mention whether the APPM feature is required for this assessment.
                    </span>
                  </label>
                  <div class="col-4 ps-1">
                    <div class="groupRadio">
                      <input type="radio" name="appm" id="appm1" v-model="isAPPM" value=1 class="radBtn"/>
                      <label for="appm1" class="radBtnLbl">Yes</label>
                      <input type="radio" name="appm" id="appm2" v-model="isAPPM" value=0  class="radBtn radBtnNo"/>
                      <label for="appm2" class="radBtnLbl">No</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mb-2 position-relative" v-show="!isTestAssessment">
                <label for="startdt">
                  Practice unit <span class="text-danger ">*</span>
                  <span class="myInfoI cursor-pointer float-right ms-2">
                    <font-awesome-icon icon="fa-solid fa-circle-info" />
                  </span>
                  <span class="myInfoS">
                    Practice unit or Business unit that you belong to. This will helpful to identify your Practice unit or
                    Business unit.
                  </span>
                </label>
                <VueMultiselect class="mymultiselect  hide-on-presentation " openDirection="bottom" v-model="practiceUnit"
                  :options="practiceUnits" :multiple="false" :allow-empty="false" deselect-label="can't Deselect"
                  :close-on-select="true" placeholder="Select Practice unit." track-by="name" label="name" selectLabel="">
                  <template v-slot:singlelabel="{ value }">
                    <div class="multiselect-single-label">
                      {{ value.name }}
                    </div>
                  </template>
                </VueMultiselect>
              </div>
              <div class="form-group padRt10 mb-2 position-relative" v-show="!isTestAssessment">
                <label style="padding-left:0px;">Enter Account Name<span class="text-danger">*</span>
                  <span class="myInfoI cursor-pointer float-right ms-2">
                    <font-awesome-icon icon="fa-solid fa-circle-info" />
                  </span>
                  <span class="myInfoS">
                    This will helpful to select the right AI models for Tagging.
                  </span>
                </label>
                <div>
                  <VueMultiselect v-model="accnamein" tag-placeholder="Add this as new Account" class="mutli-select"
                    placeholder="Search or add as a new Account" label="name" track-by="name" :options="optionsA"
                    :multiple="false" :taggable="true" @tag="addAccountTag">
                  </VueMultiselect>
                </div>
              </div>
              <div class="form-group padRt10 mb-2 position-relative" v-show="!isTestAssessment">
                <label style="padding-left:0px;">Enter Technology Used<span class="text-danger">*</span>
                  <span class="myInfoI cursor-pointer float-right ms-2">
                    <font-awesome-icon icon="fa-solid fa-circle-info" />
                  </span>
                  <span class="myInfoS">
                    Please select all the applicable technologies. This will helpful to select the right AI models for
                    Tagging.
                  </span>
                </label>
                <div>
                  <VueMultiselect v-model="tecnamein" tag-placeholder="Add this as new Technology"
                    placeholder="Search or add as a new Technology" label="name" track-by="name" :options="optionsT"
                    :multiple="true" :taggable="true" @tag="addTechTag">
                  </VueMultiselect>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <div class="effect btn-add eff-md" v-on:click="ok()">ADD</div>
          <div class="btn stdBtn btn-bordered" data-dismiss="modal" aria-label="Close" @click="cancel()" type="button">
            <b>Cancel</b>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  Modal
} from 'bootstrap';
export default {
  name: 'AddAsg',
  components: {},
  data() {
    return {
      modal: undefined,
      AssessName: "",
      AccName: "",
      TechnoName: "",
      accnamein: "",
      tecnamein: [],
      asgid: undefined,
      accfilter: [],
      techfilter: [],
      minLen: 0,
      optionsA: [],
      optionsT: [],
      isTestAssessment: false,
      isRfp: "",
      isAPPM:undefined,
      practiceUnits: [],
      practiceUnit: "",
    }
  },
  watch: {},
  methods: {
    addAccountTag(newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
      }
      this.optionsA.push(tag)
      this.accnamein = tag;
    },
    addTechTag(newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
      }
      this.optionsT.push(tag)
      this.tecnamein.push(tag);
    },
    showModal() {
      this.AssessName = ""
      this.accnamein = null
      this.tecnamein = []
      this.accfilter = [];
      this.techfilter = [];
      this.modal.show()
    },
    cancel() {
      this.modal.hide();
    },
    ok() {
      const emit = this.$emit;
      if (this.AssessName == "") {
        this.$notify({
          type: "warn",
          text: 'Please Provide the Assessment Name'
        })
      } else if (this.isRfp === "" && !this.isTestAssessment) {
        this.$notify({
          type: "warn",
          text: 'Please select it is RFP/RFI or not.'
        })
      } else if (this.isAPPM === undefined && !this.isTestAssessment) {
        this.$notify({
          type: "warn",
          text: 'Please select you will avail APPM feature or not.'
        })
      }else if (this.practiceUnit === "" && !this.isTestAssessment) {
        this.$notify({
          type: "warn",
          text: 'Please select Practice Unit.'
        })
      } else if (this.accnamein == null && !this.isTestAssessment) {
        this.$notify({
          type: "warn",
          text: 'Please Provide the Account Name'
        })
      } else if (this.tecnamein.length === 0 && !this.isTestAssessment) {
        this.$notify({
          type: "warn",
          text: 'Please Provide the Technology Details'
        })
      } else {
        if (/^[A-Za-z0-9\s&_-]+$/.test(this.AssessName) == false) {
          this.$notify({
            type: "warn",
            text: 'Assessment Name Should not contain special characters'
          })
        } else if (!this.isTestAssessment && /^[A-Za-z0-9\s&_-]+$/.test(this.accnamein.name) == false) {
          this.$notify({
            type: "warn",
            text: 'Account Name Should not contain special characters'
          })
        } else if (!this.isTestAssessment && /^[A-Za-z0-9\s&_-]+$/.test(this.tecnamein.map(name => name.name).join(' ')) == false) {
          this.$notify({
            type: "warn",
            text: 'Technology Name Should not contain special characters'
          })
        } else {
          emit("onAddAsg", true)
          this.axios.post(this.uriApiUrl + 'UserSetting/add_assessment', {
            AsgName: this.AssessName,
            AccName: this.isTestAssessment ? "Test" : this.accnamein.name,
            TechnoName: this.isTestAssessment ? "Test" : this.tecnamein.map(name => name.name).join(','),
            isRfp: this.isTestAssessment ? "Test" : this.isRfp,
            isPpm: this.isTestAssessment ? 0 : Number(this.isAPPM),
            prac_Unit: this.isTestAssessment ? "Test" : this.practiceUnit.name,
          },{
      headers: {
            'Content-Type': 'application/json'
          }})
            .then((response) => {
              if (response.status == 200) {
                if (response.data != "Exists" && response.data != "Exceed" && response.data !=
                  "TotalLimitReached" && response.data != "Error" && response.data != "Invalidinput") {
                  this.asgid = response.data
                  this.$router.push('/setup/' + this.asgid)
                  this.modal.hide()
                  this.$notify({
                    type: "success",
                    text: 'Assessment Created Successfully'
                  })
                } else if (response.data == "Exceed") {
                  this.$notify({
                    type: "error",
                    text: 'Assessment Creation per user Limit Reached!'
                  })
                  this.modal.hide()
                } else if (response.data == "TotalLimitReached") {
                  this.$notify({
                    type: "error",
                    text: 'Total Assessment Creation Limit Reached!'
                  })
                  this.modal.hide()
                } else if (response.data == "Invalidinput") {
                  this.$notify({
                    type: "error",
                    text: 'Invalid Inputs!'
                  })
                  this.modal.hide()
                } else if (response.data == "Exists") {
                  this.$notify({
                    type: "error",
                    text: 'Assessment Already Exists!'
                  })
                } else {
                  this.$notify({
                    type: "error",
                    text: 'Unable to create the assessment! Please retry and if you still face issues contact the support team'
                  })
                  this.modal.hide()
                }
                emit("onAddAsg", false)
              }
            }).catch((error) => {
              emit("onAddAsg", false)
              this.$notify({
                type: "error",
                text: "Sorry! Something went wrong. Please retry and if you still face issues contact the support team."
              })
            })
        }
      }
    },
    userinput() {
      this.axios.post(this.uriApiUrl + 'UserSetting/get_acc_tech_data')
        .then(response => {
          if (response.data != "Error") {
            this.optionsA = response.data.acc;
            this.optionsT = response.data.tech;
            this.practiceUnits = response.data.p_units;
          } else {
            this.$notify({
              type: "error",
              text: 'Sorry! Something Not able to fetch information. Try after sometime!'
            })
          }
        }).catch((error) => {
          this.$notify({
            type: "error",
            text: 'Sorry! Something Not able to fetch information. Try after sometime!'
          })
        })
    },
  },
  mounted() {
    this.modal = new Modal(document.getElementById('addAsgModal'))
    this.userinput()
  },
}
</script>
<style scoped>
.active-radio-btn {
  outline: 1px solid #ecc257;
  border-radius: 0;
}

.myInfoI:hover+.myInfoS {
  top: 36px;
  transform: translateX(-50%);
  left: 50%;
}

/* Hide inputs */
.radBtn {
  position: absolute;
  opacity: 0;
  z-index: -1;
}

.groupRadio {
  display: flex;
  align-items: center;
}

/* Styles */
.radBtnLbl {
  display: flex;
  align-items: center;
  margin-left: 1rem;
  padding: 5px 5px 5px 2rem;
    position: relative;
    cursor: pointer;
    transition: all 0.25s cubic-bezier(0.25, 0.25, 0.5, 1.9);
    z-index: 1;
}
.radBtnLbl::before {
  content: "";
  position: absolute;
  left: 0;
  width: 1.5rem;
  height: 1.5rem;
  background: transparent;
  border: 2px solid;
  border-radius: 0.25rem;
  z-index: -1;
  transition: all 0.25s cubic-bezier(0.25, 0.25, 0.5, 1.9);
}
input[type=radio] + .radBtnLbl::before {
  border-radius: 2rem;
}

/* Checked */
.radBtn:checked + .radBtnLbl {
  padding-left: 1em;
}
.radBtn:checked + .radBtnLbl::before {
  width: 100%;
  height: 100%;
  background: #4fab40;
  border: 0;
  box-shadow: 0 0 0.5rem rgba(0, 0, 0, 0.5);
}

.radBtn.radBtnNo:checked + .radBtnLbl::before {
  background-color: #ab4040;
}
.darkTheme .modal-content {
  color: #dddddd !important;
}
</style>